import type { PresentationTranslator } from './workOrderPresentation'
type PresentationPiece = { text: string; before: string; after: string }

/** Never split the protected literal tokens; whitespace survives provider trimming. */
export function splitPresentationText(text: string, maximum = 3900): PresentationPiece[] {
  const pieces: PresentationPiece[] = []
  while (text.length) {
    let cut = Math.min(maximum, text.length)
    if (cut < text.length) {
      const whitespace = text.slice(0, cut).search(/\s+\S*$/)
      if (whitespace > maximum / 2) cut = whitespace
      for (const token of text.matchAll(/__WO_KEEP_\d+__/g)) {
        if (token.index < cut && token.index + token[0].length > cut) cut = token.index
      }
    }
    const raw = text.slice(0, cut)
    text = text.slice(cut)
    const before = raw.match(/^\s*/)?.[0] ?? ''
    const after = raw.trim() ? (raw.match(/\s*$/)?.[0] ?? '') : ''
    pieces.push({ text: raw.trim(), before, after })
  }
  return pieces
}

/** All pieces must succeed before a visible field can change. */
export const translatePresentationText =
  (translatePiece: PresentationTranslator): PresentationTranslator =>
  async (request) => {
    const pieces = splitPresentationText(request.text)
    const translated = await Promise.all(
      pieces.map(async (piece) => {
        const text = piece.text ? await translatePiece({ ...request, text: piece.text }) : ''
        return piece.before + text + piece.after
      }),
    )
    return translated.join('')
  }
